import getKey from '../lib/getKey.js';

class SpatnavContainer {
    constructor(rootElement, selector, options = {}) {
        this._rootElement = rootElement;
        this._selector = selector;
        this._options = options;
        this.onNavigation = options.onNavigation || (() => {});
        const eles = this._getCandidateElements();
        this._focusedElement = eles && eles[0];

        rootElement.addEventListener('keydown', event =>
            this._handleKeydown(event)
        );
    }

    _handleKeydown(event) {
        if (!this._focusedElement) {
            return;
        }

        const prevFocusedEle = this._focusedElement;
        const activeElement = document.activeElement;
        if (activeElement.matches(this._selector)) {
            this._focusedElement = activeElement;
        }

        switch (getKey(event)) {
            case this._options.up || 'ArrowUp':
                this._navigateUp();
                break;

            case this._options.down || 'ArrowDown':
                this._navigateDown();
                break;

            default:
                return;
        }

        this.onNavigation(this._focusedElement, prevFocusedEle);
        event.stopPropagation();
        event.preventDefault();
    }

    _navigateUp() {
        const eles = this._getCandidateElements();
        if (this._focusedElement) {
            let index = eles.indexOf(this._focusedElement) - 1;
            if (index < 0) {
                index = this._options.wrap ? eles.length - 1 : 0;
            }
            this._focusedElement = eles[index];
        }

        this._focusedElement.focus();
    }

    _navigateDown() {
        const eles = this._getCandidateElements();
        if (this._focusedElement) {
            let index = eles.indexOf(this._focusedElement) + 1;
            if (index > eles.length - 1) {
                index = this._options.wrap ? 0 : eles.length - 1;
            }
            this._focusedElement = eles[index];
        }

        this._focusedElement.focus();
    }

    _getCandidateElements() {
        return [...this._rootElement.querySelectorAll(this._selector)];
    }
}

export default SpatnavContainer;



// WEBPACK FOOTER //
// ./lib/SpatnavContainer.js